import React, { useEffect, useReducer } from "react";

import './App.css';
import GeneralContext from './context/GeneralContext';
import * as GeneralReducer from './store/reducers/generalReducer';
import * as GeneralActions from './store/actions/generalActions';
import Routes from "./utils/routes";

const App = () => {
  const [state, dispatch] = useReducer(GeneralReducer.GeneralReducer, GeneralReducer.initialState);
  
  useEffect(() => {
    const users = localStorage.getItem('usersSD') !== undefined ? JSON.parse(localStorage.getItem('usersSD') || null) : null

    if(users !== null){
      let user = users.filter(userAux => userAux.isAuthenticated)
      if(user !== null && user.length > 0) {
        dispatch(GeneralActions.setLogin(user[0]))
      }
    }
  }, [ ])

  return (
    <GeneralContext.Provider
      value={{
        state,
        dispatch
      }}
    >
      <Routes />
    </GeneralContext.Provider>
  );
}

export default App;